/**
 *
 * @module streamSampleConfiguration
 *
 */

/**
 *
 * @class StreamSampleConfiguration
 *
 */
export default class StreamSampleConfiguration {

    /**
     *
     * @param {Number} [streamSampleInterval=30]
     *
     */
    constructor(streamSampleInterval = 30) {

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.streamSampleInterval = streamSampleInterval;

    }

}



// WEBPACK FOOTER //
// ./src/services/media/streamSampleConfiguration.js